<template>
  <v-card
    :class="active ? 'blue-grey lighten-5' : ''"
    class="ma-3 mr-12"
    elevation="4"
    @dblclick="$emit('try-edit-note')"
  >
    <v-chip :color="note.importance | color" label class="d-flex">
      <v-card-title class="pl-2">
        <v-icon left> {{ note.importance | icon }} </v-icon>
        <div v-if="!note.hubspot && note.assessment.number != null">
          Note taken in
          <span v-if="note.assessment.number == 0" class="font-weight-bold">Initial check-in</span>
          <span v-else class="font-weight-bold">Check-in {{ note.assessment.number }} </span>

          <span v-if="note.assessment.date"> ({{ note.assessment.date | fancyShortDate }})</span>
        </div>
        <div v-if="note.title" class="font-weight-bold" style="font-size: 20px">{{ note.title }}<br /></div>
      </v-card-title>
    </v-chip>
    <v-card-subtitle class="py-1">
      <div class="blue-grey--text text--lighten-2 text-right">
        {{ note.createdAt | fancyDate }}
      </div>
    </v-card-subtitle>

    <v-card-text v-if="note.hubspot" v-html="note.note"> </v-card-text>
    <v-card-text v-else class="pb-0 mb-0">
      <span class="authentic-note">{{ note.note }}</span>
    </v-card-text>

    <v-card-actions>
      <div class="ml-n2">
        <v-card-title class="d-inline-flex pb-3">
          <div class="blue-grey--text text--lighten-2 ml-auto">
            <span>{{ note.coach }}</span>
          </div>
        </v-card-title>
        <v-card-subtitle class="blue-grey--text text--lighten-2">
          <span v-if="note.hubspot">via Hubspot</span>
          <span v-else>via Coaching Platform</span>
        </v-card-subtitle>
      </div>

      <div v-if="!note.hubspot && !note.assessment.id" class="ml-auto mt-auto">
        <v-spacer />
        <v-btn small @click="$emit('edit-note')">Edit</v-btn>
        <v-btn small color="error" @click="$emit('delete-note')" class="ma-2">Delete</v-btn>
      </div>

      <div v-if="!note.hubspot && note.assessment.id" class="ml-auto mt-auto">
        <v-spacer />
        <v-btn small :to="assessmentLink(note.assessment.id)" target="_blank" class="ma-2">View Check-in</v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { fancy_date } from "@/lib/fancy_date";

export default {
  name: "NoteCard",
  props: {
    note: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    fancyDate(date) {
      return fancy_date(date);
    },
    fancyShortDate(date) {
      return fancy_date(date, "D MMMM YYYY", false);
    },
    color(importance) {
      let map = {
        info: "info",
        warning: "warning",
        urgent: "error",
        assessment: "primary",
      };

      return importance ? map[importance.toLowerCase()] : "secondary";
    },
    icon(importance) {
      let map = {
        info: "mdi-notebook",
        warning: "mdi-alert-circle",
        urgent: "mdi-alert-decagram",
        assessment: "mdi-calendar-text",
      };

      return importance ? map[importance.toLowerCase()] : "mdi-folder";
    },
  },
  methods: {
    assessmentLink(id) {
      return {
        name: "CoachClientAssessments",
        params: { coachId: this.coachId, userId: this.selectedUserId },
        query: {
          assessmentId: id,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.authentic-note {
  white-space: pre-line;
  font-size: 16px;
  color: black;
}
</style>